import { useTheme } from 'styled-components';

import { Typography } from '../../../designComponents';
import { ourStrengthData } from './data';
import OurStrengthCounts from './OurStrengthCounts';
import { ContainerStyled, OurStrengthStyled } from './style';

const OurStrength = () => {
  const theme = useTheme();
  return (
    <OurStrengthStyled>
      <ContainerStyled>
        <Typography
          style={{ color: theme.colors.landingSecondaryText }}
          variant="heading"
          strong
          className="main-text"
        >
          Our Strength is Quantified By Numbers
        </Typography>
        <div className="our-strength-data">
          {ourStrengthData.map((data, idx) => (
            <OurStrengthCounts
              key={idx}
              count={data.count}
              desc={data.desc}
              label={data.label}
            />
          ))}
        </div>
      </ContainerStyled>
    </OurStrengthStyled>
  );
};

export default OurStrength;
